import { useInactiveUpdate } from 'apps/builder/lib/hooks/inputHooks'

export const ModernInput = ({
  id,
  placeholder,
  value = '',
  onChange,
  label,
  tooltipComponent,
  disabled,
  validation = false,
  autoFocus = false,
  truncate = false,
  additionalClasses,
  additionalProps = {},
}) => {
  const {
    inputValue,
    errors,
    handleChange,
    handleBlur,
    handleKeyUp
  } = useInactiveUpdate(value, validation, onChange, {...additionalProps})

  return (
    <div
      className={`foundry--input-fields modern--input
        ${errors ? 'foundry--field-error' : ''} ${
        additionalClasses ? additionalClasses : ''
      }`}
    >
      <input
        id={id}
        className={`input-fields__input ${truncate ? 'clipped-text' : ''}`}
        value={inputValue}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onChange={({ target }) => {
          const { value } = target
          handleChange(value)
        }}
        onKeyUp={handleKeyUp}
        onBlur={handleBlur}
        disabled={disabled}
        {...additionalProps}
      />
      {label && (
        <label htmlFor={id} className="input-fields__label">
          {label}
          {tooltipComponent}
        </label>
      )}
      {errors && (
        <div className="field-error--wrap">
          <i className="field-error--icon icon--solid foundry-icon icon--exclamation-triangle"></i>
          <span className="field-error--message">{errors}</span>
        </div>
      )}
    </div>
  )
}
